<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
  >
    <v-card >
      <v-card-title class="docgo white--text title">
        <v-icon class="pr-4" color="white">
          mdi-briefcase-account-outline
        </v-icon>
        <span>
          {{dialogTitle}}
        </span>
      </v-card-title>

        <v-form ref="roleForm" class="pa-4" v-model="roleForm" lazy-validation>
          <v-layout>
            <v-flex>
              <span class="subheading font-weight-bold grey--text text--darken-1">Informações</span>
              <v-layout>
                  <v-text-field
                    label="Nome"
                    persistent-hint
                    v-model="role.name"
                    :rules="[validationRules.required]"
                  />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      <v-card-actions class="px-4 pb-4">
        <v-btn
          flat
          :loading="isSaving"
          @click="closeDialog()"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="saveUpdateRole()"
          :loading="isSaving"
          :disabled="!roleForm"
        >
          <v-icon class="pr-2">
            mdi-content-save
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import validationRules from '@/mixins/validation-rules';
  import RoleService from '@/services/system/RoleService';

  export default {
    name: "role-form",
    props: ['dialog'],
    data() {
      return {
        role: {},
        roleForm: true,
        isSaving: false,
        validationRules,
      };
    },
    computed: {
      selectedRole() {
        return this.$store.getters.role;
      },
      dialogTitle() {
        return (this.role && this.role.id) ? 'Editar Cargo' : 'Novo Cargo';
      },
    },
    methods: {
      closeDialog() {
        this.$emit('update:dialog', false);
        this.resetForms();
      },
      resetForms() {
        this.$refs.roleForm.resetValidation();
      },
      validateForms() {
        this.$refs.roleForm.validate();
      },
      saveUpdateRole() {
        this.validateForms();
        if (this.$refs.roleForm.validate()) {
          const formData = new FormData();
          formData.append('name', this.role.name);

          this.isSaving = true;
          if (this.role.id) {
            RoleService.update(formData, this.role.id)
              .then(() => {
                this.$store.dispatch('toggleSnackbar', {
                  show: true,
                  timeout: 6000,
                  color: 'success',
                  message: 'Cargo atualizado com sucesso!',
                  messageIcon: 'mdi-check',
                });
                this.closeDialog();
                this.$emit('updateList');
              }).catch((request) => {
                this.$store.dispatch('toggleSnackbar', {
                  show: true,
                  timeout: 6000,
                  color: 'error',
                  message: request.response.data.toString(),
                  messageIcon: 'mdi-check',
                });
              }).finally(() => {
                this.isSaving = false;
              });
          } else {
            RoleService.create(formData)
              .then(({ data }) => {
                this.$store.dispatch('toggleSnackbar', {
                  show: true,
                  timeout: 6000,
                  color: 'success',
                  message: 'Cargo criado com sucesso!',
                  messageIcon: 'mdi-check',
                });
                this.closeDialog();
                this.$emit('updateList');
              }).catch((request) => {
                this.$store.dispatch('toggleSnackbar', {
                  show: true,
                  timeout: 6000,
                  color: 'error',
                  message: request.response.data.toString(),
                  messageIcon: 'mdi-check',
                });
              }).finally(() => {
                this.isSaving = false;
              });
          }
        }
      },
    },
    watch: {
      selectedRole: {
        handler: function(val) {
            this.role = Object.assign({}, val);
            if(this.role.id)
              this.validateForms();
            else
              this.resetForms();
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/role/RoleForm.vue